import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Config, ConfigService} from '../config';
import {PostcodeResponseDto} from "../dto/postcode-response-dto";
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private config = this.configService.getConfig().rool

  setConfig(config: Config) {
    this.config = config.rool;
  }

  uploadFile(file: File, url: string, info?: any) {
    if(info) {
      Sentry.captureMessage('Upload picture', {extra: {url, info, size: file.size}});
    }
    return this.http.put<Response>(url, file, {observe: 'response'});
  }

  ///////////////// api.gouv.fr //////////////////

  getPostcode(postcode: string) {
    return this.http.get<PostcodeResponseDto[]>(`https://apicarto.ign.fr/api/codes-postaux/communes/${postcode}`);
  }

}
